<template>
  <div>
    <div class="w-100 px-0 py-0">
      <div slot="title">
        <h1>{{sesionDeLaAudiencia.Audiencia != undefined && sesionDeLaAudiencia.Audiencia != null ? sesionDeLaAudiencia.Audiencia.TipoDocumento.Nombre : "Cargando sesión de la audiencia"}} {{sesionDeLaAudiencia.Audiencia != undefined ? sesionDeLaAudiencia.Audiencia.Consecutivo : ""}}</h1>
        <div class="d-flex">
          <h3>Vídeo grabado en la sala {{sesionDeLaAudiencia.Sala != undefined && sesionDeLaAudiencia.Sala != null ? sesionDeLaAudiencia.Sala.Nombre : ""}}</h3>&nbsp;
        </div>
      </div>
      <div class="row d-flex ">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
          <div>                        
            <div class="area" v-if="!mostrarSubidorDeVideo && sesionDeLaAudiencia != null && sesionDeLaAudiencia.LocalizacionDeLosVideos.LocalizacionDeLosVideosId == 3 && sesionDeLaAudiencia.SeHanCreadoLosVideos && LosVideosHanSidoCreados" :key="sesionDeLaAudiencia.SeHanCreadoLosVideos + LosVideosHanSidoCreados">  
              <div class="justify-content-end text-right">
                <button class="btn btn-primary" v-on:click="respaldarVideosEnServidor()">Respaldar vídeos a servidor central</button>
              </div>
            </div>
            <br v-if="!mostrarSubidorDeVideo && sesionDeLaAudiencia != null && sesionDeLaAudiencia.LocalizacionDeLosVideos.LocalizacionDeLosVideosId == 3 && sesionDeLaAudiencia.SeHanCreadoLosVideos && LosVideosHanSidoCreados" :key="sesionDeLaAudiencia.SeHanCreadoLosVideos + LosVideosHanSidoCreados"/>
            <div class="area">
              <h3>Seleccione un marcador</h3>
              <hr />
              <div class="form-group flex-wrap">
                <C005TiposMarcador v-on:valorParaElPadre="marcaElTipoDeMarcador" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'grabacion_TiposMarcador'" :valorDefinido="marcador.TipoMarcador.TipoMarcadorId" :parametros="{}"></C005TiposMarcador>
              </div>
              <div v-if="marcador.TipoMarcador.TipoMarcadorId == 99 || marcador.TipoMarcador.TipoMarcadorId == 94" class="form-group flex-wrap">
                <label for="grabacion_Comentarios" class="mb-2">Comentarios</label>
                <textarea class="form-control" id="grabacion_Comentarios" v-model="marcador.Comentarios" rows="3"></textarea>
              </div>
              <div v-if="marcador.TipoMarcador.TipoMarcadorId == 94" class="form-group">
                <label for="grabacion_Receso">Receso</label>
                <input type="text" id="grabacion_Receso" class="form-control" v-model="marcador.DuracionDelReceso" v-mask="'##:##'" placeholder="hh:mm">
              </div>
              <div id="subidorAudienciasFinalizadas_div" v-if="marcador.TipoMarcador.TipoMarcadorId == 57 && mostrarEvidencias">
                <br />
                <h6>Evidencias</h6>
                <hr />
                <div class="form-group flex-wrap">
                  <C034TipoEvidencia v-on:valorParaElPadre="marcaElTipoDeEvidencia" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'evidencia_TiposEvidencia'" :valorDefinido="evidencia.TipoEvidencia.TipoEvidenciaId" :key="evidencia.TipoEvidencia.TipoEvidenciaId" :parametros="{}"></C034TipoEvidencia>
                </div>
                <div class="form-group flex-wrap">
                  <input type="text" class="form-control" placeholder="Titulo" v-model="evidencia.Titulo" />
                </div>
                <div class="form-group flex-wrap">
                  <textarea type="text" class="form-control" placeholder="Descripción" v-model="evidencia.Descripcion" />
                </div>
                <div id="subidorArchivosPruebas_div">
                  <div>
                    <input type="file" id="archivoPrueba" v-on:change="cargarArchivo($event)" class="form-control" />
                    <br />
                  </div>
                </div>
                <div class="justify-content-end text-right">
                  <button class="btn btn-primary" v-on:click="agregarEvidencia()">Agregar evidencia</button>
                </div>
                <div id="evidenciasDiv" class="evidencias">
                  <br />
                  <ul class="form-group list-group">
                    <li v-for="evidencia in listaDeEvidencias" class="list-group-item">
                      <span>{{evidencia.TipoEvidencia.Nombre}}</span><br />
                      <span>{{evidencia.Titulo}}</span><br />
                      <span>{{evidencia.Descripcion}}</span><br />
                      <span v-if='evidencia.Ruta != ""'>{{evidencia.Ruta}}</span>
                      <br v-if='evidencia.Ruta != ""' />
                    </li>
                  </ul>
                </div>
              </div>
              <br />
              <div class="justify-content-end text-right">
                <button class="btn btn-primary" v-on:click="guardarMarcador()">Agregar marcador</button>
              </div>
              <br />
              <div class="justify-content-end text-right">
                <button class="btn btn-danger" v-on:click="terminarSesion()">Terminar sesión</button>
              </div>
            </div>
            <br />
            <div class="area marcadores">
              <h3>Marcadores</h3>
              <hr />
              <ul class="form-group list-group">
                <li v-for="marcador in sesionDeLaAudiencia.Marcadores" class="list-group-item" @click="cargarEnVideo(marcador)">
                  <h6 v-html="obtenElTiempoDelMarcadorConFormato(marcador.Tiempo, true)"></h6>
                  <span>{{marcador.TipoMarcador.Nombre}}<br v-if="marcador.TipoMarcador.TipoMarcadorId == 94" />{{marcador.TipoMarcador.TipoMarcadorId == 94 ? obtenElTiempoDelMarcadorConFormato(marcador.DuracionDelReceso, false) : ""}}</span>
                  <br />
                  <span v-if="marcador.TipoMarcador.TipoMarcadorId == 99 || marcador.TipoMarcador.TipoMarcadorId == 94">Observaciones: {{marcador.Comentarios}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
          <div v-if="!mostrarSubidorDeVideo" class="area">
            <h3>REPRODUCTOR DE LA SESIÓN</h3>
            <hr />
            <div v-if="sesionDeLaAudiencia != null && sesionDeLaAudiencia.EnServidor == false">
              Los videos aun no se han almacenado en el servidor, por lo que su reproducción no es posible.
              <div class="text-right">
                <button class="btn btn-danger" v-on:click="iniciaLaCopiaDeLosVideosAProduccion()"><i class="fas fa-upload"></i>&nbsp;&nbsp;Almacenar los videos en servidor</button>
              </div>
              <br />
            </div>
            <Reproductor v-if="sesionDeLaAudiencia != null" :componentesDeCamaras="componentesDeCamaras" :reproducirVideo="true" :parametros="sesionDeLaAudiencia" :key="sesionDeLaAudiencia.SesionDeLaAudienciaId" v-on:EstadoReproductor="estadoVideo($event)"></Reproductor>
          </div>
          <br />          
          <div v-if="mostrarSubidorDeVideo" :key="mostrarSubidorDeVideo" class="area">
            <h3>Subir vídeo</h3>
            <hr />
            <div id="subidorVideo_div">
              <label>Seleccionar archivo .mp4</label>
              <input type="file" id="archivoVideo" v-on:change="cargarArchivoDeVideo($event)" class="form-control" accept=".mp4,.MP4" />
              <br />
            </div>
            <div class="justify-content-end text-right" v-if="ArchivoDeVideo != null">
              <button class="btn btn-primary" v-on:click="agregarVideo()">Agregar vídeo</button>
            </div>
          </div>
          <div class="text-right">        
            <button class="btn btn-sm btn-dark"  @click='regresarEdicion()'>Volver a Validación de Audiencia</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sistemas from '@/../static/js/sistemas';
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import router from '@/router/index'

  export default {
    components: {
      enumeraciones,
      Reproductor: sistemas.Forseti.Reproductor,
      C005TiposMarcador: catalogos.Forseti.C005TiposMarcador,
      C034TipoEvidencia: catalogos.PJ.C034TipoEvidencia,
    },
    data() {
      return {
        enumeraciones,
        sesionDeLaAudiencia: {
          LocalizacionDeLosVideos:{
            LocalizacionDeLosVideosId: -1
          }
        },
        componentesDeCamaras: [
          { componenteDeCamaraId: enumeraciones.componentesDeCamaras.Comenzar },
          { componenteDeCamaraId: enumeraciones.componentesDeCamaras.Reproducir },
          { componenteDeCamaraId: enumeraciones.componentesDeCamaras.LineaDeTiempo }
        ],
        mostrarEvidencias: true,
        mostrarSubidorDeVideo: false,
        marcador: {
          TipoMarcador: {
            TipoMarcadorId: -1
          },
          Evidencias: null,
          Comentarios: null,
          DuracionDelReceso: null,
          Tiempo: null
        },
        listaDeEvidencias: [],
        Archivos: [],
        ArchivoDeVideo: null,
        evidencia: {
          TipoEvidencia: {
            TipoEvidenciaId: -1
          },
        },
        SesionTerminada: false,
        LosVideosHanSidoCreados: false, 
        LosVideosEstanEnServidor: false,
        VideoEnReproduccion:false
      }
    },
    props: {
      SesionDeLaAudienciaId: Number,
      AudienciaId: Number
    },
    mounted() { 
      this.obtenSesionDeLaAudiencia(null);
    },

    filters: {
    },
    methods: {
      terminarSesion() {
        let audienciaId = this.AudienciaId;
        this.SesionTerminada = true;

        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Desea terminar de editar la sesión?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
              router.push({ name: "EdicionYAsignacion", params: { AudienciaId: audienciaId } });
            }
          }
        });
      },
      agregarVideo: function () {
        if (this.ArchivoDeVideo == null) {
          comun.mensajeDeAlerta("Seleccione archivo.", null, null);
        } else {
          let datosDelFormulario = new FormData();

          datosDelFormulario.append('EsPrueba', this.enumeraciones.EsPrueba);
          datosDelFormulario.append('ArchivoDeVideo', this.ArchivoDeVideo);
          datosDelFormulario.append('SesionDeLaAudienciaId', this.SesionDeLaAudienciaId);

          axios.post(
            api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.GuardarVideo,
            datosDelFormulario,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              document.getElementById("archivoVideo").value = "";
              this.ArchivoDeVideo = null;
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
        }
      },
      cargarArchivoDeVideo: function (evento) {
        if (evento.target.files.length > 0) {
          this.ArchivoDeVideo = evento.target.files[0];
        } else {
          this.ArchivoDeVideo = null;
        }
      },
      cargarArchivo: function (evento) {
        if (evento.target.files.length > 0) {
          this.Archivos.push(evento.target.files[0]);
          this.evidencia.Ruta = evento.target.files[0].name;
        } else {
          this.Archivos = null;
        }
      },
      cargarEnVideo: function (marcador) {
        this.listaDeEvidencias = [];
        let tiempo = marcador.Tiempo;
        // this.sesionDeLaAudiencia.RutasDeVideos.forEach((element) => {
        // const videoCamara = document.getElementById("camara" + element.Camara.CamaraId);
        const videoCamara = document.getElementById("video_sesion" + this.sesionDeLaAudiencia.SesionDeLaAudienciaId);
        
          //  if (!videoCamara)
          //   return

          var seconds = (+tiempo.split(':')[0]) * 60 * 60 + (+tiempo.split(':')[1]) * 60 + (+tiempo.split(':')[2]);
          videoCamara.currentTime = parseInt(seconds);
          
        // });

        this.marcador = {
          TipoMarcador: {
            TipoMarcadorId: marcador.TipoMarcador.TipoMarcadorId
          },
          Evidencias: marcador.Evidencias,
          Comentarios: marcador.Comentarios,
          DuracionDelReceso: marcador.DuracionDelReceso,
          Tiempo: marcador.Tiempo
        }

        marcador.Evidencias.forEach((element) => {
          element.Ruta = "";
          this.listaDeEvidencias.push(element);
        });
      },
      obtenElTiempoDelMarcadorConFormato: function (tiempo, conSegundos) {
        const formatoDeTiempo = tiempo.split(":");
        return "Tiempo: " + formatoDeTiempo[0] + ":" + formatoDeTiempo[1] + (conSegundos ? "." + formatoDeTiempo[2] : "");
      },
      validarMarcadorAAgregar: function () {
        if (this.marcador.TipoMarcador.TipoMarcadorId == undefined || this.marcador.TipoMarcador.TipoMarcadorId <= 0) {
          comun.mensajeDeAlerta("Seleccione el tipo de marcador para poder guardarlo.", null, null);
          return false;
        }

        //const videoCamara = document.getElementById("camara" + this.sesionDeLaAudiencia.RutasDeVideos[0].Camara.CamaraId);
        //if (!videoCamara)
          //return false

        //if (videoCamara.currentTime <= 0) {
          //comun.mensajeDeAlerta("Reproduzca el vídeo para poder agregar tiempo al marcador.", null, null);
          //return false;
        //}

        if (this.marcador.TipoMarcador.TipoMarcadorId == 99 || this.marcador.TipoMarcador.TipoMarcadorId == 94) {
          if (this.marcador.Comentarios == "") {
            comun.mensajeDeAlerta("Ingrese las observaciones.", null, null);
            return false;
          }

          if (this.marcador.TipoMarcador.TipoMarcadorId == 94) {
            if (!moment(this.marcador.DuracionDelReceso, "HH:mm A").isValid()) {
              comun.mensajeDeAlerta("Ingrese el tiempo de receso.", null, null);
              return false;
            }
          }
        }

        return true;
      },
      validarEvidenciaAAgregar: function () {
        if (this.marcador.TipoMarcador.TipoMarcadorId == 57) {
          if (this.evidencia.TipoEvidencia == null || this.evidencia.TipoEvidencia.TipoEvidenciaId <= 0) {
            comun.mensajeDeAlerta("Ingrese tipo de evidencia.", null, null);
            return false;
          }

          if (this.evidencia.Titulo == null || this.evidencia.TipoEvidencia.TipoEvidenciaId == "") {
            comun.mensajeDeAlerta("Ingrese título de evidencia.", null, null);
            return false;
          }

          if (this.Archivos.length < this.listaDeEvidencias.length) {
            comun.mensajeDeAlerta("Seleccione archivo.", null, null);
            return false;
          }
        } else {
          comun.mensajeDeAlerta("En este marcador no se admiten pruebas.", null, null);
          return false;
        }

        return true;
      },
      limpiarDatosMarcador: function () {
        this.marcador = {
          TipoMarcador: {
            TipoMarcadorId: -1
          },
          Evidencias: null,
          Comentarios: null,
          DuracionDelReceso: null,
          Tiempo: null
        }

        this.listaDeEvidencias = [];
      },
      limpiarDatosEvidencia: function () {
        this.evidencia = {
          TipoEvidencia: {
            TipoEvidenciaId: -1
          },
        }

        document.getElementById("archivoPrueba").value = "";
      },
      agregarEvidencia: function () {
        this.validarEvidenciaAAgregar();
        //Se valida evidencia
        if (this.validarEvidenciaAAgregar()) {
          this.listaDeEvidencias.push(this.evidencia);
          this.limpiarDatosEvidencia();
        }
      },
      guardarMarcador: function () {
        if(this.VideoEnReproduccion==true){
        if (this.validarMarcadorAAgregar()) {
          comun.SeEstaCargandoInformacion(true);
          //Recibo tiempo en segundos
          this.marcador.Tiempo = new Date(this.$store.state.Forseti_Sistema_TiempoActualVideo['reproductor_tiempoActualVideo'] * 1000).toISOString().substr(11, 8);
          if (this.listaDeEvidencias.length > 0)
            this.marcador.Evidencias = this.listaDeEvidencias;

          let datosDelFormulario = new FormData();
          this.Archivos.forEach((element) => {
            datosDelFormulario.append(element.name, element);
          });

          datosDelFormulario.append('EsPrueba', this.enumeraciones.EsPrueba);
          datosDelFormulario.append('SesionDeLaAudienciaId', this.SesionDeLaAudienciaId);
          datosDelFormulario.append('Marcador', JSON.stringify(this.marcador));

          axios.post(
            api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.GuardarMarcador,
            datosDelFormulario,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              this.sesionDeLaAudiencia.Marcadores.push(Object.assign("", this.marcador));
              this.marcador = {
                TipoMarcador: {
                  TipoMarcadorId: -1
                },
                Comentarios: null,
                DuracionDelReceso: null,
                Tiempo: null
              };
              this.mostrarEvidencias = true;
              this.limpiarDatosMarcador();

              const parametros = {
                llave: "grabacion_TiposMarcador",
                valor: this.marcador.TipoMarcador.TipoMarcadorId
              }
              this.$store.dispatch("A_Forseti_Catalogo_Establecer005TipoMarcador", parametros);
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          });
        }
        }else{
          comun.mensajeDeAlerta("Para agregar marcadores, el video debe estar reproduciéndose.", null, null);
        }
      },
      obtenElTiempoDelMarcadorConFormato: function (tiempo, conSegundos) {
        const formatoDeTiempo = tiempo.split(":");
        return "Tiempo: " + formatoDeTiempo[0] + ":" + formatoDeTiempo[1] + (conSegundos ? "." + formatoDeTiempo[2] : "");
      },
      marcaElTipoDeMarcador: function (datos) {
        // this.marcador.TipoMarcador = {
        //   TipoMarcadorId: parseInt(datos.target.value),
        //   Nombre: datos.target[datos.target.selectedIndex].label
        // }
        this.marcador.TipoMarcador = {
          TipoMarcadorId: parseInt(datos.TipoMarcadorId),
          Nombre: datos.Nombre
        }
      },
      marcaElTipoDeEvidencia: function (datos) {
        this.evidencia.TipoEvidencia = {
          TipoEvidenciaId: parseInt(datos.target.value),
          Nombre: datos.target[datos.target.selectedIndex].label
        }
      },
      obtenSesionDeLaAudiencia: function (sesionDeLaAudienciaId) {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          SesionDeLaAudienciaId: sesionDeLaAudienciaId == null ? this.SesionDeLaAudienciaId : sesionDeLaAudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        };

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.ObtenSesionDeLaAudienciaPorVerificar,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          comun.SeEstaCargandoInformacion(false);

          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
          } else { 
            this.sesionDeLaAudiencia = respuesta.data.SesionDeLaAudienciaPendiente;
            //debugger

            let t = this.sesionDeLaAudiencia;
            if(this.sesionDeLaAudiencia.RutasDeVideos[0].Camara != null && this.sesionDeLaAudiencia.RutasDeVideos[0].Camara.TipoCamara.TipoCamaraId ==  enumeraciones.camaras.HandyCam)
              this.mostrarSubidorDeVideo = true;            
            
            this.LosVideosHanSidoCreados = true;
            if(!this.mostrarSubidorDeVideo) {               
              switch(this.sesionDeLaAudiencia.LocalizacionDeLosVideos.LocalizacionDeLosVideosId) {
                // case 2:
                  //Cambio: no habrá servidor específico de procesamiento, el merge se hará en la sala.
                  // this.iniciaLaCopiaDeLosVideosAProcesamiento();                  
                  // break;
                // case 3:
                  // Cambio: La unión de los vídeos se realiza al terminar la grabación
                  // if(!this.sesionDeLaAudiencia.SeHanCreadoLosVideos)
                  //   this.iniciaLaUnionDeLosVideosDeLaSesion();
                  // else
                    // this.LosVideosHanSidoCreados = true;
                  // break;
                case 4:
                  this.LosVideosHanSidoCreados = true;
                  this.LosVideosEstanEnServidor = true;
                  break;
              }
            }

            // if (!this.mostrarSubidorDeVideo && !this.sesionDeLaAudiencia.SeHanCreadoLosVideos)
            //   this.iniciaLaUnionDeLosVideosDeLaSesion();
            // else {
            //   this.LosVideosHanSidoCreados = true;
            //   if (!this.sesionDeLaAudiencia.EnServidor)
            //     this.iniciaLaCopiaDeLosVideosAProduccion();
            //   else
            //     this.LosVideosEstanEnServidor = true;
            // }
          }
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
        });
      },
      iniciaLaCopiaDeLosVideosAProcesamiento() {
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          SesionDeLaAudienciaId: this.sesionDeLaAudiencia.SesionDeLaAudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.RealizarCopiaDeLosArchivosAlMerge,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          comun.SeEstaCargandoInformacion(false);

          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
          } else {
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
            this.obtenSesionDeLaAudiencia(this.sesionDeLaAudiencia.SesionDeLaAudienciaId);
          }
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
        });
      },
      iniciaLaUnionDeLosVideosDeLaSesion() {
        this.LosVideosHanSidoCreados = false;
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          Videos: this.sesionDeLaAudiencia.RutasDeVideos,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          'http://' + this.sesionDeLaAudiencia.Audiencia.ServidorPorAreaDeProcesamientoDelVideo.IPDelServidor + this.sesionDeLaAudiencia.Sala.PuertoDeFinalizacion + api.Forseti.sistema.audiencias.audienciasPorVerificar.CreaLosVideosDeLaSesionDeLaAudiencia,
          parametros
        ).then(respuesta => {
          if (respuesta.data.Errores.length > 0) {
            console.log(respuesta);
            comun.mensajeDeAlerta("La grabación no se ha podido ejecutar correctamente.", null, null);
          } else {
            const parametrosDeRespuesta = {
              RutasDeVideos: respuesta.data.Videos,
              SesionDeLaAudienciaId: this.SesionDeLaAudienciaId,
              EsPrueba: this.enumeraciones.EsPrueba
            }

            axios.post(
              api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.GuardaLaCreacionLosVideosDeLaSesionDeLaAudiencia,
              parametrosDeRespuesta,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
              comun.SeEstaCargandoInformacion(false);

              if (respuesta.data.SiHayError) {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              } else {
                this.LosVideosHanSidoCreados = true;
                //comun.mensajeDeAlerta(respuesta.data.Satisfactorio + "<br /><br />A continuación, se hara la transferencia de los videos al servidor.", null, null);
                //Cambio: Se comenta para agregar la opción de manera manual si es necesario. 16/04/2021
                //this.iniciaLaCopiaDeLosVideosAProduccion();
              }
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
            });
          }
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
        });
      }, 
      respaldarVideosEnServidor(){        
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Se realizará el respaldo de los vídeos al servidor central.<br />¿Desea continuar?",
          buttons: {
                cancel: {
                  label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
                },
                confirm: {
                  label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si, iniciar respaldo'
                }
              },
              callback: async (respuestaDelBootBox) => {
                if(respuestaDelBootBox) {
                  this.iniciaLaCopiaDeLosVideosAProduccion();
                }
              }
        });      
      },
      iniciaLaCopiaDeLosVideosAProduccion() {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          SesionDeLaAudienciaId: this.sesionDeLaAudiencia.SesionDeLaAudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.RealizarCopiaDeLosArchivosAlServidor,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          comun.SeEstaCargandoInformacion(false);

          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
          } else {
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
            this.obtenSesionDeLaAudiencia(this.sesionDeLaAudiencia.SesionDeLaAudienciaId);
          }
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
        });
      },
      regresarEdicion(){
            router.push({ name: 'EdicionYAsignacion', params: {AudienciaId: this.AudienciaId}})
        },
        estadoVideo(estado){
		     this.VideoEnReproduccion=estado.Estatus;
      }
    },
    beforeRouteLeave(to, from, next) {
      if (!this.SesionTerminada)
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Actualmente se encuentra verificando una audiencia. De Abandonar este proceso, perderá toda la información.<br />¿Realmente desea salir?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si, salir de la verificación'
            }
          },
          callback: function (respuesta) {
            if (respuesta)
              next()
            else
              next(false)
          }
        });
      else
        next()
    }
  }
</script>

<style scoped>
  .marcadores {
    height: 520px;
  }

    .marcadores ul {
      overflow-y: auto;
      height: 400px;
    }

      .marcadores ul li {
        background-color: #504f54;
        border: 1px solid rgba(0,0,0,.125);
      }

  .evidencias {
    max-height: 520px;
  }

    .evidencias ul {
      overflow-y: auto;
      max-height: 400px;
    }

      .evidencias ul li {
        background-color: #504f54;
        border: 1px solid rgba(0,0,0,.125);
      }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPorVerificar/EdicionVideo.vue